[
  {
    "id": "off-coach-1111-2222-3333-444444444441",
    "market_id": "mkt-coach-2026-10-19-01",
    "coach_id": "c0010000-0000-0000-0000-000000000001",
    "signing_bonus": 1500000,
    "annual_salary": 2200000,
    "release_clause": 8000000,
    "score": 1780000,
    "submitted_at": "2026-10-19T14:30:00Z",
    "arrival": 105,
    "status": "PENDING"
  },
  {
    "id": "off-coach-1111-2222-3333-444444444442",
    "market_id": "mkt-coach-2026-08-14-01",
    "coach_id": "c1a23456-7890-4abc-def0-123456789001",
    "signing_bonus": 1200000,
    "annual_salary": 2400000,
    "release_clause": 10000000,
    "score": 1680000,
    "submitted_at": "2026-08-14T12:00:00Z",
    "arrival": 50,
    "status": "WON"
  },
  {
    "id": "off-coach-1111-2222-3333-444444444443",
    "market_id": "mkt-coach-2026-08-10-01",
    "coach_id": "c9990000-0000-0000-0000-000000000099",
    "signing_bonus": 1000000,
    "annual_salary": 1500000,
    "release_clause": 6000000,
    "score": 1200000,
    "submitted_at": "2026-08-10T16:00:00Z",
    "arrival": 42,
    "status": "LOST"
  },
  {
    "id": "off-coach-1111-2222-3333-444444444444",
    "market_id": "mkt-coach-2026-08-05-01",
    "coach_id": "c8880000-0000-0000-0000-000000000088",
    "signing_bonus": 2000000,
    "annual_salary": 3000000,
    "release_clause": 12000000,
    "score": 2400000,
    "submitted_at": "2026-08-05T11:00:00Z",
    "arrival": 31,
    "status": "INSUFFICIENT_FUNDS"
  },
  {
    "id": "off-coach-1111-2222-3333-444444444445",
    "market_id": "mkt-coach-2026-08-02-01",
    "coach_id": "c7770000-0000-0000-0000-000000000077",
    "signing_bonus": 1000000,
    "annual_salary": 2000000,
    "release_clause": 5000000,
    "score": 1400000,
    "submitted_at": "2026-08-02T09:15:00Z",
    "arrival": 20,
    "status": "CANCELLED"
  }
]
